var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-zoom","duration":200,"mode":"in-out"}},[(_vm.modal)?_c(_vm.modal,_vm._b({tag:"component",on:{"hide":function($event){return _vm.$emit('hide')}}},'component',_vm.props,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }